module.exports = __webpack_public_path__ + "static/media/bookService.1d3d63f1.svg";